import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a486ec0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "layout-top-bar"
}
const _hoisted_2 = { class: "layout-app-container" }
const _hoisted_3 = {
  key: 0,
  style: {"height":"var(--app-top-bar-height)"}
}
const _hoisted_4 = { class: "layout-footer" }

import {useRoute} from "vue-router";
import {computed, watchEffect} from "vue";
import TopBar from "@/views/layout/TopBar.vue";
import FooterView from "@/views/layout/Footer.vue";
import {tenant} from "@/store";



const __default__ = {
  name: "Layout"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const route = useRoute()
const keepAlive = computed(() => {
  return route.meta.keepAlive === true
})

const fullscreen = computed(() => {
  return route.meta.fullscreen === true
})

const id = computed(() => {
  return route.fullPath
})

watchEffect(() => {
  if (tenant.value) {
    document.title = tenant.value.name
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(fullscreen))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(TopBar)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_unref(fullscreen))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, null, {
        default: _withCtx(({Component}) => [
          (_openBlock(), _createBlock(_KeepAlive, null, [
            (_unref(keepAlive))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: _unref(id) }))
              : _createCommentVNode("", true)
          ], 1024)),
          (!_unref(keepAlive))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: _unref(id) }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(FooterView)
    ], 512), [
      [_vShow, !_unref(fullscreen)]
    ])
  ]))
}
}

})